import * as React from "react";
import Component from "../../AbstractComponent";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import Select from "../../Partials/Material/Select";
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "../../Partials/Material/TextField";
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

export class ChargeTypeUpdate extends Component {
  public state = {
    chargeType: this.props.chargeType,
    label: "",
    chargeClass: null
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    const state = {
      label: this.props.chargeType.label,
      chargeClass: this.props.chargeType.chargeClassId
    };

    this.setState(state);
  }

  public onCancelType = (): any => {
    if (typeof this.props.onCancelType === "function") {
      this.props.onCancelType.call(this);
    }
  }

  public onSaveType = (useHideSwitch): any => {
    if (typeof this.props.onSaveType === "function") {
      this.props.onSaveType.call(this, {
        label: this.state.label,
        chargeClass: this.state.chargeClass
      }, useHideSwitch);
    }
  }

  public updateChargeClass = (event) => {
    this.setState({
      chargeClass: event.target.value
    });
  }

  public updateChargeName = (event) =>{
    this.setState({
      label: event.target.value
    })
  }

  public render() {
    const isPayable = this.state.chargeClass == ChargeClassContainer.pickIdFromLabel("Payable");

    return (
      <div>
        <div>
          <div style={{display: "flex", justifyContent: "flex-end", margin: "-5px -16px -10px 0"}}>
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.chargeType?.removed}
                  onChange={this.onSaveType.bind(this, true)}
                  color="primary"
                />
                }
              label={this.trans("label-hide")}
            />
          </div>

          <TextField
            autoComplete="off"
            id="label"
            className="form-element full-size scroll-to-label"
            type="text"
            label={this.trans("charge-type-name")}
            value={this.state.label}
            onChange={this.updateChargeName}
            autoFocus={true}
            variant="standard"
            error={!!this.getErrorFor("label")}
          />
          {!!this.getErrorFor("label") && <div className="component-error-text">{this.getErrorFor("label")}</div>}

          <Select
            className="form-element full-size form-input scroll-to-chargeClass correct-label-position"
            error={this.getErrorFor("chargeClass")}
            disabled={true}
            value={isPayable ? ChargeClassContainer.pickIdFromLabel("Payable") : ChargeClassContainer.pickIdFromLabel("Receivable")}
            htmlFor="chargeClass"
            label={this.trans("charge-class-id-type")}
            name="chargeClass" 
            id="chargeClass"
          >
            {
              <MenuItem
                value={isPayable ? ChargeClassContainer.pickIdFromLabel("Payable") : ChargeClassContainer.pickIdFromLabel("Receivable")}
                key={isPayable ? ChargeClassContainer.pickIdFromLabel("Payable") : ChargeClassContainer.pickIdFromLabel("Receivable")}
              >
              {isPayable ? this.trans(`${ChargeClassContainer.pickLabelFromId(ChargeClassContainer.pickIdFromLabel("Payable"))}`) : this.trans(`${ChargeClassContainer.pickLabelFromId(ChargeClassContainer.pickIdFromLabel("Receivable"))}`)}
              </MenuItem>
            }
          </Select>
        </div>

        <DialogActions>
          <div className="button-container">
            <Button
              color="primary"
              onClick={this.onCancelType}
            >
              {this.trans("button-cancel")}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={this.onSaveType.bind(this, false)}
            >
              {this.trans("button-save")}
            </Button>
          </div>
        </DialogActions>
      </div>
    );
  }
}
